/**
 * Report type enum — mirrors `ReportType` in `@linkhr/api-client`'s
 * missing-schemas.ts, which in turn mirrors the backend's.
 *
 * There are deliberately NO per-report params schemas here. What a report's
 * generate body accepts is declared by `GET /reports/catalog` at runtime and
 * rendered from there (`apps/hr-admin/src/features/reports/reportParams.ts`).
 * The hand-written schemas this file used to carry had drifted from that
 * contract — they named `from`/`to` where six reports take `fromDate`/`toDate`
 * or two ranges, and each of those generates came back 400 REPORT_INVALID_PARAMS.
 */

import { z } from "zod";

export const ReportTypeEnum = z.enum([
  "HEADCOUNT",
  "EMPLOYEE_ROSTER",
  "EMP_SHIFTS",
  "PAYROLL_SUM",
  "ATTENDANCE_SUM",
  "LEAVE_BALANCE",
  "PUNCHES_DETAILS",
  "DAILY_TIMESHEETS",
  "TERMINATIONS",
  "SALARY_RECONCILIATIONS",
  "DISCIPLINARY_ACTION",
  "LOANS",
  "OVERTIME_BY_DEPT",
]);
export type ReportTypeEnum = z.infer<typeof ReportTypeEnum>;
